import styled from 'styled-components';
import { colors } from 'spw-theme';
import { ColorBubble } from 'spw-components/dialogs/styles';
import { Box } from '@mui/material';

export const ColorSwatch = styled.div`
  && {
    width: 14px;
    height: 20px;
    box-sizing: border-box;
    background-color: ${(props) => props.color} !important;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      border: solid 1px ${colors.white};
    }

    &.selected {
      border: solid 2px ${colors.white};
    }
  }
`;

export const SmallColorBubble = styled(ColorBubble)`
  width: 20px;
  height: 20px;
  margin-right: 6px;
`;

export const HexValue = styled(Box)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
